import { Maybe } from 'graphql/jsutils/Maybe';
import { TuiFlagPipeModule } from '@taiga-ui/core';
import { Locale } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ImageUrlPipe, ToTuiCountryIsoCodePipe } from '@iss/wo-common/pipes';

@Component({
  selector: 'wo-country-flag',
  templateUrl: './country-flag.component.html',
  styleUrls: [ './country-flag.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ImageUrlPipe,
    ToTuiCountryIsoCodePipe,
    TuiFlagPipeModule,
  ],
})
export class CountryFlagComponent {
  @Input({ required: true }) code: Maybe<Locale>;
}
